import React from 'react';
import YouTube from 'react-youtube';
import PropTypes from 'prop-types';

const YouTubeModal = (props) => {
  const { showYoutubeModal, videoId } = props;
  const options = {
    playerVars: {
      autoplay: 1,
    },
  };
  const escListener = (e) => {
    if (e.keyCode === 27) showYoutubeModal();
    window.removeEventListener('keyup', escListener);
  };
  window.addEventListener('keyup', escListener);
  return (
    <div className="youtube-modal-container">
      <div onClick={showYoutubeModal} className="modal-backdrop" />
      <div className="player-container" onClick={showYoutubeModal}>
        <YouTube opts={options} videoId={videoId} />
      </div>
    </div>
  );
};

YouTubeModal.propTypes = {
  showYoutubeModal: PropTypes.func,
  videoId: PropTypes.string,
};

export default YouTubeModal;
